import { Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';
import { soulWiseTheme } from '../../mui-theme';

export const SWDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    background: soulWiseTheme.palette.sea80,
    color: '#fff',
  },
  '& .MuiDialogTitle-root': {
    textAlign: 'center',
    fontSize: '18px', // --headline-text-size-h3
    padding: '12px 24px',
  },
  '& .MuiDialogContent-root': {
    borderColor: 'rgba(255, 255, 255, 0.1)',
    padding: '0px 24px',
  },
  '& .MuiDialogActions-root': {
    justifyContent: 'space-between',
    background: soulWiseTheme.palette.sea70,
    padding: '16px 24px',
  },
  [theme.breakpoints.up('md')]: {
    '& .MuiDialog-paper': {
      maxWidth: '800px',
      borderRadius: '16px',
    },
    // Fullscreen dialogs must override the default 800px cap above.
    // Declared after `.MuiDialog-paper` so it wins at equal specificity.
    '& .MuiDialog-paperFullScreen': {
      maxWidth: '100vw',
      width: '100%',
      height: '100%',
      margin: 0,
      borderRadius: 0,
    },
    '& .MuiDialogActions-root': {
      borderRadius: '0 0 16px 16px',
    },
  },
}));
